import React, { FC, useEffect, useRef } from 'react';
import { Card, Text } from '@resideo/blueprint-react';
import Page from 'components/common/Page';
import { useTranslation } from 'react-i18next';
import { useLocation } from 'react-router-dom';

export type ErrorProps = {
  header?: string;
  content?: string;
  resetError?: () => void;
};

const PageError: FC<ErrorProps> = ({ header, content, resetError }) => {
  const { t } = useTranslation();
  const Location = useLocation();
  const hasMounted = useRef(false);

  useEffect(() => {
    if (!hasMounted.current) {
      hasMounted.current = true;
      return;
    }
    if (resetError) {
      resetError();
    }
  }, [Location]);

  return (
    <Page as='main' data-test-page-error>
      <Card borderRadius={[0, 'medium']} padding='large'>
        <h1>{header || t('pageError.defaultHeader')}</h1>
        <Text>{content || t('pageError.defaultContent')}</Text>
      </Card>
    </Page>
  );
};

export default PageError;
